<template src="../templates/normal_fcont_141.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import DesignPaperTiles from '../components/DesignPaperTiles'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import AppDownloadCreative from '../components/AppDownloadCreative'
import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '141',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,
    PrintButton,DesignPaperTiles,ReleaseDateForArticle,
    AppDownloadCreative
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['141-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['141-2']}
    ]};

  }
  
};
</script>
<style >

</style>

